import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import { environment } from '../../../environments/environment'

import { NbGenre } from './genre.service'

export interface NbDj {
  id: number
  name: string
  genre: NbGenre[]
  description: string
  myspace?: string
  twitter?: string
  twitter_widgetid?: string
  facebook?: string
  instagram?: string
  instagram_userid?: string
  website?: string
  permalink?: string
  youtube_username?: string
  active?: boolean
  date_entered?: string
  images: { id: number; filename: string; ordering: number }[]
  thumbnail: string
  image: string
  mix_thumbnail: string
}

export interface NbDjsResponse {
  success: boolean
  djs: NbDj[]
}

export interface NbDjResponse {
  success: boolean
  dj: NbDj
}

export interface NbDjSuccessResponse {
  success: boolean
}

@Injectable()
export class DjService {
  private API_ENDPOINT = `${environment.HOST}/adminapi/dj/`

  constructor(private http: HttpClient) {}

  public getAllDjs(): Observable<NbDjsResponse> {
    return this.http.get(`${this.API_ENDPOINT}getlist/sort/name`).map((res) => res as NbDjsResponse)
  }

  public getAllInstructors(): Observable<any> {
    return this.http.get(`${this.API_ENDPOINT}gettrainers/sort/name`).map((res) => res)
  }

  public getDjById(id: number): Observable<NbDjResponse> {
    return this.http.get(`${this.API_ENDPOINT}getdj/id/${id}`).map((res) => res as NbDjResponse)
  }

  public saveDj(dj: NbDj): Observable<any> {
    return this.http.post(`${this.API_ENDPOINT}save`, dj).map((res) => res)
  }

  public deleteDj(id: number): Observable<NbDjSuccessResponse> {
    return this.http.get(`${this.API_ENDPOINT}delete/id/${id}`, {}).map((res) => res as NbDjSuccessResponse)
  }
}



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/app/@core/data/dj.service.ts